'use client';

import styled from 'styled-components';

export const NavbarBase = styled.nav`
  display: flex;
  flex-direction: column;

  width: 100%;
  
  background: var(--navbar-background, #fff);

`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  max-width: 1176px;
  padding: 0 8px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr min-content;

  grid-template-areas: 
    "logo group"
    "below below";


  box-sizing: border-box;
`;

export const Group = styled.div`
  grid-area: group;

  display: flex;
  justify-content: flex-end;

  min-height: 70px;

  @media (max-width: 768px) {
    min-height: 56px;
  }
`;
